import App from './App';
import React from 'react';
import './styles/index.css';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { isEqual } from './contexts/Utils';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Miscellaneous variables 
export const isDevEnv = isEqual(window.location.hostname, "localhost");

// Register the service worker
if (!isDevEnv) serviceWorkerRegistration.register();

// UnRegister the service worker
if (isDevEnv) serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
